import request from "../../utils/fetch";

// fetch data
export const getDashboardData = (postData) => 
  request.post(`coupons/dashboard`, postData);